/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type VideoEditQueryVariables = {
    id: string;
};
export type VideoEditQueryResponse = {
    readonly videoById: {
        readonly id: string;
        readonly name: string;
        readonly description: string | null;
        readonly public: boolean;
    } | null;
};
export type VideoEditQuery = {
    readonly response: VideoEditQueryResponse;
    readonly variables: VideoEditQueryVariables;
};



/*
query VideoEditQuery(
  $id: ID!
) {
  videoById(id: $id) {
    id
    name
    description
    public
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Video",
    "kind": "LinkedField",
    "name": "videoById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "public",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoEditQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoEditQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79fb9b988249b46b396850f9e7eb1561",
    "id": null,
    "metadata": {},
    "name": "VideoEditQuery",
    "operationKind": "query",
    "text": "query VideoEditQuery(\n  $id: ID!\n) {\n  videoById(id: $id) {\n    id\n    name\n    description\n    public\n  }\n}\n"
  }
};
})();
(node as any).hash = '07e72fddb038cc7f009248706cb6a2cb';
export default node;
